export default __webpack_public_path__ + "static/media/password_key.8f89b27d.svg";